/**
 * LowFodmaps's mark: a single leaf on a deep-green tile. Inline so it scales
 * crisply; the same drawing ships as public/icon.svg (the favicon) and as the
 * landing's icon. Keep the three in step. The hexes are the brand's own,
 * deliberately not theme tokens.
 */
export function LogoMark({ size = 32, className }: { size?: number; className?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" className={className} aria-hidden>
      <rect width="48" height="48" rx="14" fill="#1f3a34" />
      <path
        d="M24 37c-7.2 0-12-4.6-12-11.2C12 17.4 19 12 31.5 11c1.8 0 3.5 1 3.5 3.2C35 27.6 31 37 24 37Z"
        fill="#5fa88c"
      />
      <path d="M17.5 33.5C21 27 25.5 21.5 31 17" stroke="#1f3a34" strokeWidth="2.2" strokeLinecap="round" fill="none" />
    </svg>
  )
}
